document.addEventListener('alpine:init', () => {
    Alpine.data('tripCollection', () => ({
        showAll: false,
        itemsToShow: 4, // This will be overridden by the PHP value

        init() {
            // Get the initial trips to show value from the data attribute
            const container = this.$el;
            const initialTripsToShow = container.dataset.initialTripsToShow;
            
            if (initialTripsToShow) {
                this.itemsToShow = parseInt(initialTripsToShow);
            }
        },

        viewMore() {
            this.showAll = true;
        }
    }));
});
